export default "__VITE_ASSET__BdjsXPcl__"